<template lang="html">
<div class="bg-grey-lightest">
  <div class="container mx-auto">
    <div class="flex items-center px-4 py-16 md:pt-32 flex-col-reverse md:flex-row">
      <div class="w-full md:w-1/2">
        <img class="mb-2" src="../assets/sun-icon.svg">
        <p class="title text-pink">Your sources. Combined.</p>
        <h3 class="header">Search Custom Sources</h3>
        <p class="paragraph">
          Pick from a list of suggested Custom Sources curated for the technologies and tools from your <strong>Developer Profile</strong>.
        </p>
        <p class="paragraph">
          You can also add your own websites to search through!
        </p>
        <p class="paragraph">
          Whenever you make a search, you will be able to access to the search results on those websites using our <strong>built-in browser</strong>.
        </p>
      </div>
      <div class="w-full md:w-1/2 text-right md:ml-8 mb-8">
        <img
          data-rellax-speed="0.5"
          class="rellax sources-img rounded-lg"
          src="../assets/custom-sources.png"
          alt="Custom Sources Screenshot"
        >
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {}
</script>

<style lang="sass">
.sources-img
  box-shadow: 0 25px 40px 0 rgba(0,0,0,0.20)
</style>
